import { render, staticRenderFns } from "./EmployeeWorkforceGrid.vue?vue&type=template&id=32cfe96e&scoped=true&"
import script from "./EmployeeWorkforceGrid.vue?vue&type=script&lang=js&"
export * from "./EmployeeWorkforceGrid.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeWorkforceGrid.vue?vue&type=style&index=0&id=32cfe96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cfe96e",
  null
  
)

export default component.exports